/*
 * Detached scrollbars for the account popups, at every breakpoint.
 * Content scrolls inside the scroller (native bar hidden by CSS); a sibling
 * .acd-popup__scrollbar rail reflects scroll position and supports drag.
 * Same pattern and look as the Size Chart bar (sections/size-chart.liquid).
 * Auto-attaches when a scroller enters the DOM and tears down (removing all
 * document/window listeners) when it is removed — e.g. Vue v-if close.
 */
(function () {
  var MIN_THUMB = 40;
  // Every popup scroller that carries a rail; markup comes from snippets/acd-popup-scrollbar.liquid
  var SCROLLERS = [
    '.acd-popup__content',
    '.earn-info-popup__panel',
    '.give-stars-popup__panel',
    '.membership-benefits__scroll-row .mtt-scroll-outer'
  ].join(',');
  var instances = new Map(); // content element -> teardown fn

  function initScroller(content) {
    if (instances.has(content) || !content.parentNode) return;

    // the rail is a sibling — it lives in the same flex row as the scroller
    var bar = content.parentNode.querySelector(':scope > .acd-popup__scrollbar');
    if (!bar) return;
    var track = bar.querySelector('.acd-popup__scrollbar-track');
    var thumb = bar.querySelector('.acd-popup__scrollbar-thumb');
    if (!track || !thumb) return;

    var dragging = false;
    var startY = 0;
    var startScroll = 0;
    var visible = null;

    // hide the whole rail (not just the track) so its column and the flex gap
    // collapse when there is nothing to scroll
    function setVisible(v) {
      if (visible === v) return;
      visible = v;
      bar.style.display = v ? '' : 'none';
    }

    function metrics() {
      var sh = content.scrollHeight;
      var ch = content.clientHeight;
      var trackH = track.clientHeight;
      var thumbH = Math.max(MIN_THUMB, (ch / sh) * trackH);
      return { sh: sh, ch: ch, trackH: trackH, thumbH: thumbH, maxTop: trackH - thumbH };
    }

    function update() {
      setVisible(true); // lay the rail out before measuring the track
      var m = metrics();
      if (m.sh <= m.ch + 1) {
        setVisible(false);
        return;
      }
      var top = m.maxTop * (content.scrollTop / (m.sh - m.ch));
      thumb.style.height = m.thumbH + 'px';
      thumb.style.transform = 'translateY(' + top + 'px)';
    }

    function onMove(e) {
      if (!dragging) return;
      var m = metrics();
      if (m.maxTop <= 0) return;
      var dy = e.clientY - startY;
      content.scrollTop = startScroll + (dy / m.maxTop) * (m.sh - m.ch);
    }

    function onUp() {
      dragging = false;
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
    }

    function onDown(e) {
      dragging = true;
      startY = e.clientY;
      startScroll = content.scrollTop;
      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', onUp);
      e.preventDefault();
    }

    content.addEventListener('scroll', update, { passive: true });
    thumb.addEventListener('pointerdown', onDown);
    window.addEventListener('resize', update);

    var ro = null;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(update);
      ro.observe(content);
      // the table/panel can outgrow the scroller without the scroller resizing
      if (content.firstElementChild) ro.observe(content.firstElementChild);
    }

    requestAnimationFrame(update);

    instances.set(content, function teardown() {
      content.removeEventListener('scroll', update);
      thumb.removeEventListener('pointerdown', onDown);
      window.removeEventListener('resize', update);
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      if (ro) ro.disconnect();
    });
  }

  function scan() {
    var scrollers = document.querySelectorAll(SCROLLERS);
    for (var i = 0; i < scrollers.length; i++) initScroller(scrollers[i]);
  }

  function reap() {
    instances.forEach(function (teardown, content) {
      if (!document.contains(content)) {
        teardown();
        instances.delete(content);
      }
    });
  }

  var mo = new MutationObserver(function () {
    reap();
    scan();
  });

  function boot() {
    mo.observe(document.body, { childList: true, subtree: true });
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
